// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"234":"b21275c4","559":"1deb8043"}[chunkId] + ".css";
};